export const INITIAL_SEND_DATETIME = 'initial_send_datetime';

export const REPEAT_SEND_DATETIMES = 'repeat_send_datetimes';

export const SHOULD_REPEAT_SEND = 'should_repeat_send';
